// web shim - @didomi/react-native is native-only.
// CMP isn't wired up on web; provide no-ops so imports resolve.

const noop = () => {};
const asyncNoop = () => Promise.resolve();

export const Didomi = {
  initializeWithParameters: asyncNoop,
  setUser: asyncNoop,
  setUserStatus: asyncNoop,
  setUserAgreeToAll: asyncNoop,
  setUserDisagreeToAll: asyncNoop,
  showPreferences: asyncNoop,
  showNotice: asyncNoop,
  hideNotice: noop,
  hidePreferences: noop,
  reset: noop,
  addEventListener: noop,
  removeEventListener: noop,
  onReady: () => Promise.resolve(),
  getCurrentUserStatus: () => ({}),
  getUserStatus: () => ({}),
  getRequiredPurposeIds: () => [],
  getRequiredVendorIds: () => [],
  getUserConsentStatusForPurpose: () => false,
  getUserConsentStatusForVendor: () => false,
  shouldConsentBeCollected: () => Promise.resolve(false),
};

export const DidomiEventType = {};
export const CurrentUserStatus = {};
export const DidomiInitializeParameters = {};
export const Purpose = {};

export default { Didomi, DidomiEventType, CurrentUserStatus, Purpose };
